import React, { useEffect } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import { QueryClient, QueryClientProvider } from "react-query";

import {
  CommandList,
  defaultKeyboardShortcuts,
} from "@folio/stripes/components";
import { useStripes } from "@folio/stripes/core";

import { routesConfig } from "./routesConfig";
import { RouteGuard } from "./guards/RouteGuard";
import { ErrorBoundary } from "./components/ErrorBoundary";
import CznaUsersSettings from "./settings";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0,
      cacheTime: 0,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
    },
  },
});

const CznaUsers = ({ match, actAs }) => {
  const stripes = useStripes();
  useEffect(() => {
    if (stripes.timezone === "UTC") stripes.setTimezone("Europe/Prague");
  }, [stripes]);

  if (actAs === "settings") {
    return <CznaUsersSettings {...{ match }} />;
  }

  return (
    <QueryClientProvider client={queryClient}>
      <ErrorBoundary>
        <CommandList commands={defaultKeyboardShortcuts}>
          <Switch>
            {Object.values(routesConfig).map((route) => (
              <Route
                key={route.path}
                path={`${match.path}${route.path}`}
                render={(routeProps) => (
                  <RouteGuard allowedRoles={route.roles}>
                    <route.component {...routeProps} />
                  </RouteGuard>
                )}
              />
            ))}
            <Redirect from={match.path} to={`${match.path}/users`} />
          </Switch>
        </CommandList>
      </ErrorBoundary>
    </QueryClientProvider>
  );
};

CznaUsers.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }).isRequired,
  actAs: PropTypes.string,
};

export default CznaUsers;
